import m from "../../../../geodata/es2015/region/usa/msHigh";
window.am4geodata_region_usa_msHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/msHigh.js
// module id = null
// module chunks = 